import axios from '../axios';

export default class ServiceHistoryServices {
  async getContractByTechnicianName(technician_login) {
    let res = await axios.get(`Contract/GetContractByTechnicianName?technician_login=${technician_login}`);
    return res.data;
  }

  async getHistoryleader(phone) {
    let phoneConverted = phone.slice(0, 2) == '55' ? phone : '55' + phone;
    let res = await axios.get(`/Contract/GetContractsByLeaderPhone?leaderPhone=${phoneConverted}`);
    return res.data;
  }

  async getOsByContract(contract) {
    let res = await axios.get(`/Contract/GetOsByContract?contractNumber=${contract}`);
    return res.data;
  }

  async checkLeaderLoginRelease(phone) {
    let phoneConverted = phone.slice(0, 2) == '55' ? phone : '55' + phone;
    let res = await axios.get(`/Services/leaderRelease?phone=${phoneConverted}`);
    return res.data;
  }

  async checkLeaderLogin(login) {
    let res = await axios.get(`/Services/checkLeaderLogin?login=${login}`);
    return res.data;
  }

  async approveRequest(id) {
    let res = await axios.post(`/Services/approveRequest?id=${id}`);
    return res.data;
  }

  async denyRequest(id) {
    let res = await axios.post(`/Services/denyRequest?id=${id}`);
    return res.data;
  }


  async getDefaultTechnicianDataByLogin(technician_login) {
    var data = {
      login_tecnico: technician_login
    }
    let res = await axios.post(`Technician/GetTechnicianByLogin`, data);
    return res.data;
  }

}